module.exports = __webpack_public_path__ + "media/images/version_merge/secure_gmo-6d49d5a4ae7706b4278c807dda0ac6a3.png";